const { TRANSLATED_UGC_URL, FLOWS_BI_DATA_UGC_MAPPER } = require('../utils/constants');

const buildTranslationConfig = (translateUGC, locale, userId, knownCrawler, flow) => {

    if (!translateUGC || knownCrawler) {
        return undefined;
    }

    return {
        translationServiceUrl: TRANSLATED_UGC_URL,
        locale,
        knownCrawler,
        sourceInfo: {
            ...FLOWS_BI_DATA_UGC_MAPPER[flow],
            user: {
                id: userId
            }
        }
    };
};

const createBiData = ({ userId = '', userGuid = '', flow }) => ({
    ...FLOWS_BI_DATA_UGC_MAPPER[flow],
    user: {
        id: userId
    },
    userGuid
});

module.exports = {
    buildTranslationConfig,
    createBiData
};
